import { createVideoBanner } from '.';
import { queryAll, query } from '~/lib/utils/dom';
queryAll('.js-video-banner')
    .map((main) => ({
    main,
    video: query('.js-video-banner-video', main),
    toggleBtn: query('.js-video-banner-toggle-btn', main),
}))
    .map(createVideoBanner);
